import { useQuery } from "@tanstack/react-query";
import getStatuses from '@/services/status/list'

export const useStatus = () => {
    return useQuery({
        queryKey: ["status"],
        queryFn: getStatuses,
        initialData: []
    });
};
